((document, window, history) => {
	const pushState = history.pushState;

	// default cookie compliance script
	function cookieCompliance() {
		if (document.querySelector('.farlo-ui-biscuit-banner__button')) {
			document.querySelector('.farlo-ui-biscuit-banner__button').addEventListener('click', (e) => {
				e.preventDefault();

				e.target.closest('.farlo-ui-biscuit-banner').classList.add('farlo-ui-biscuit-banner--hide');

				window._farlo.storage.set('cookieCompliance', 'true', 'cookie');
			});
		}

		if (document.querySelector('.farlo-ui-biscuit-banner__button--close')) {
			document.querySelector('.farlo-ui-biscuit-banner__button--close').addEventListener('click', (e) => {
				e.preventDefault();

				e.target.closest('.farlo-ui-biscuit-banner').classList.add('farlo-ui-biscuit-banner--hide');
			});
		}
	}

	document.addEventListener('DOMContentLoaded', function() {
		const thumbnailList = document.querySelector('.flex-control-thumbs');

		if (thumbnailList) {
			const thumbnails = Array.from(thumbnailList.querySelectorAll('li'));

			if (thumbnails) {
				// Loop through each thumbnail and check if its child image has the 'flex-active' class
				thumbnails.forEach((thumbnail) => {
					const thumbnailImage = thumbnail.querySelector('img');
					if (thumbnailImage && thumbnailImage.classList.contains('flex-active')) {
						thumbnail.classList.add('flex-active');
					}
				});
			}

			const activeThumbnail = thumbnailList.querySelector('.flex-active');
			const activeIndex = thumbnails.indexOf(activeThumbnail);

			// Move the active thumbnail to the first position
			if (activeIndex > 0) {
				const distanceToMove = -activeThumbnail.offsetWidth * activeIndex;
				thumbnailList.style.transform = `translateX(${ distanceToMove }px)`;
			}
		}
	});

	// default navicon
	function navicon() {
		document.querySelector('.site-navigation__navicon').addEventListener('click', (e) => {
			e.preventDefault();
			e.currentTarget.classList.toggle('site-navigation__navicon--active'); document.querySelector('.site-navigation').classList.toggle('site-navigation--active');
			document.body.classList.toggle('site-navigation__nav--open');
		});
	}

	function updateCart() {
		let timeout;
		const woocommerce = document.querySelectorAll('.woocommerce');
		woocommerce.forEach(function(container) {
			container.addEventListener('click', function(event) {
				if (timeout !== undefined) {
					clearTimeout(timeout);
					console.log('function running');
				}
				timeout = setTimeout(function() {
					document.querySelector('.actions .button').click(); // trigger cart update
				}, 1000); // 1 second delay, half a second (500) seems comfortable too
			});
		});
	}

	function openFAQ() {
		if (window.innerWidth > 992) {
			const firstFaqElement = document.getElementById('faq1');
			if (firstFaqElement) {
				firstFaqElement.classList.add('site-faqs__accordion-faq--active');
			}
		}
	}

	// default navigation subnav
	function navigation(submenu) {
		if (('ontouchstart' in window) ||
        (navigator.maxTouchPoints > 0) ||
        (navigator.msMaxTouchPoints > 0)) {
			window._farlo.helpers.getSiblings(submenu)[ 0 ].addEventListener('click', (e) => {
				if (!e.target.classList.contains('site-navigation__menu-item--active')) {
					e.preventDefault();

					e.currentTarget.classList.add('site-navigation__menu-item--active');
					submenu.classList.add('site-navigation__sub-menu--active');

					for (let i = 0; i < window._farlo.helpers.getSiblings(e.currentTarget.parentNode).length; i += 1) {
						if (window._farlo.helpers.getSiblings(e.currentTarget.parentNode)[ i ].children[ 0 ] && window._farlo.helpers.getSiblings(e.currentTarget.parentNode)[ i ].children[ 0 ].classList.contains('site-navigation__menu-item--active')) {
							window._farlo.helpers.getSiblings(e.currentTarget.parentNode)[ i ].children[ 0 ].classList.remove('site-navigation__menu-item--active');
						}

						if (window._farlo.helpers.getSiblings(e.currentTarget.parentNode)[ i ].children[ 1 ] && window._farlo.helpers.getSiblings(e.currentTarget.parentNode)[ i ].children[ 1 ].classList.contains('site-navigation__sub-menu--active')) {
							window._farlo.helpers.getSiblings(e.currentTarget.parentNode)[ i ].children[ 1 ].classList.remove('site-navigation__sub-menu--active');
						}
					}
				} else {
					return true;
				}
			});
		} else {
			submenu.parentNode.addEventListener('mouseover', () => {
				if (submenu.parentNode.querySelector('.site-navigation__sub-menu--active')) {
					submenu.parentNode.querySelectorAll('.site-navigation__sub-menu--active').forEach((_sel) => {
						_sel.classList.remove('site-navigation__sub-menu--active');
						_sel.parentNode.classList.remove('site-navigation__menu-item--active');
					});
				}
				submenu.classList.add('site-navigation__sub-menu--active');
				submenu.parentNode.classList.add('site-navigation__menu-item--active');
			});

			submenu.parentNode.addEventListener('mouseout', () => {
				submenu.classList.remove('site-navigation__sub-menu--active');
				submenu.parentNode.classList.remove('site-navigation__menu-item--active');
			});
		}
	}

	function headerSearch() {
		document.querySelector('.site-header__search-icon').addEventListener('click', (e) => {
			e.stopImmediatePropagation();

			e.currentTarget.parentNode.querySelector('.site-header__search-form-container').classList.toggle('site-header__search-form-container--active');
		});
	}

	function faqs() {
		const accordions = document.querySelectorAll('.site-faqs__accordion-faq');

		const openAccordion = (accordion) => {
			const answer = accordion.querySelector('.site-faqs__accordion-answer');
			accordion.classList.add('site-faqs__accordion-faq--active');
			answer.style.maxHeight = answer.scrollHeight + 'px';
		};

		const closeAccordion = (accordion) => {
			const answer = accordion.querySelector('.site-faqs__accordion-answer');
			accordion.classList.remove('site-faqs__accordion-faq--active');
			answer.style.maxHeight = null;
		};

		accordions.forEach((accordion) => {
			const question = accordion.querySelector('.site-faqs__accordion-question');
			const answer = accordion.querySelector('.site-faqs__accordion-answer');

			question.onclick = () => {
				if (answer.style.maxHeight) {
					closeAccordion(accordion);
				} else {
					accordions.forEach((acc) => closeAccordion(acc));
					openAccordion(accordion);
				}
			};
		});
	}

	function carousels(_sel) {
		if (_sel.children.length > 1) {
			const config = {
				cellAlign: 'center',
				wrapAround: true,
				draggable: true,
				pageDots: false,
				prevNextButtons: false,
				autoPlay: 6000,
				lazyLoad: false
			};

			if (_sel.classList.contains('site-reviews')) {
				config.pageDots = true;
				config.adaptiveHeight = true;
			}

			if (_sel.classList.contains('site-masthead__images')) {
				config.setGallerySize = false;
			}

			const carousel = new Flickity(_sel, config);
		}
	}

	history.pushState = function(state) {
		if (typeof history.onpushstate === 'function') {
			history.onpushstate({ state });
		}
		return pushState.apply(history, arguments);
	};

	document.addEventListener('DOMContentLoaded', () => {
		if (document.querySelector('.site-navigation__navicon')) {
			navicon();
		}

		if (document.querySelector('.site-navigation__sub-menu')) {
			document.querySelectorAll('.site-navigation__sub-menu').forEach((_sel) => {
				navigation(_sel);
			});
		}

		if (document.querySelector('.site-farlo-ui-biscuit-banner')) {
			cookieCompliance();
		}

		if (document.querySelector('.site-faqs')) {
			faqs();
		}

		if (document.querySelector('.site-header__search')) {
			headerSearch();
		}

		if (document.querySelector('.site-carousel')) {
			document.querySelectorAll('.site-carousel').forEach((_sel) => {
				carousels(_sel);
			});
		}
		if (document.querySelector('.site-page__cart')) {
			updateCart();
		}
		if (document.querySelector('.site-faqs__accordions')) {
			openFAQ();
		}
	});
})(document, window, history);
